import * as React from 'react'
import { observer } from 'mobx-react'
import { sortOptions } from './collection-sort.options'
import "./collection-sort.scss";
import { Dropdown, Icon, IDropdownOption } from '../../shared'
import { filterBarStore } from '../filter-bar'

interface IProps {
  className?: string
}

const CollectionSort: React.FC<IProps> = observer(({ className }) => {
  const handleOptionOnclick = (value: IDropdownOption): void => {
    const opt = sortOptions.find((option) => option.value === value.value)
    if (!opt) return
    filterBarStore.activeSortBy = opt.value
  }

  const opt = sortOptions.find((option) => option.value === filterBarStore.activeSortBy)

  return (
    <div className='dropdown__collection-sort'>
      <span className='sort-title'>Sort:</span>
      <Dropdown
        className={`${className || ''}`}
        trigger={
          <button className='sort-button'>
            {opt?.label || 'Default'} 
            <Icon icon='down' /> 
          </button>
        }
        options={sortOptions}
        optionClickHandler={handleOptionOnclick}
      />
    </div>
  )
})

export default CollectionSort
